import { render, staticRenderFns } from "./ActivityLogEntryAttributeControl.vue?vue&type=template&id=a2ca2d44&scoped=true&lang=pug&"
import script from "./ActivityLogEntryAttributeControl.vue?vue&type=script&lang=ts&"
export * from "./ActivityLogEntryAttributeControl.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityLogEntryAttributeControl.vue?vue&type=style&index=0&id=a2ca2d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca2d44",
  null
  
)

export default component.exports